module.exports = __webpack_public_path__ + "static/media/ts14tj0.e5a1acdf.png";